exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".menu__time__picker__input input {\n  width: 62px;\n  padding: 0px;\n  font-size: 13px !important;\n  text-align: center;\n  margin-bottom: -1px;\n  margin-top: 3px;\n  cursor: pointer; }\n\n.menu__time__picker__input.time-picker-no-underline div::before {\n  border-bottom: none; }\n\n.menu__time__picker__input.time-picker-no-underline input {\n  cursor: default !important; }\n\n.menu_editor_time_wrapper {\n  display: 'flex';\n  flex-direction: 'column';\n  width: 164px; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js?sourceMap=true!./node_modules/sass-resources-loader/lib/loader.js??ref--1-oneOf-3-3!./src/components/Dashboard/Panels/MenuEditor/components/MenuList/index.scss
// module id = 6466
// module chunks = 1